import './index.scss';

import * as OffcanvasMenu from '../assets-base/assets-src/js/Spinao/OffcanvasMenu';
import najainit from "./najainit";

const naja = najainit();

document.addEventListener("DOMContentLoaded", function() {
    OffcanvasMenu.initialize();

    document.addEventListener('submit', function (event) {
        let eventTarget = event.target as HTMLElement;
        if(eventTarget.matches('form[data-cms-ajax="form"]')) {
            event.preventDefault();

            let form = eventTarget as HTMLFormElement;
            let refresh = form.dataset.cmsRefresh;
            let returnInput = form.querySelector('[name="returnLink"]');
            let reloadUrl = returnInput ? returnInput.getAttribute('value') : window.location.href

            naja.uiHandler.submitForm(form, {unique: "off", history: false})
                .then((payload: { result: { message: any; }; }) => {
                    naja.makeRequest('GET', reloadUrl, {
                        'refresh': refresh,
                        'success': payload.result.message,
                        '_fid': '',
                    }, { history: false });
                })
                .catch((error: { hasOwnProperty: (arg0: string) => any; response: { json: () => Promise<any>; }; }) => {
                    if(error.hasOwnProperty('response')) {
                        error.response.json().then((payload) => {
                            naja.makeRequest('GET', reloadUrl, {
                                'refresh': refresh,
                                'error': payload.result.message,
                                '_fid': '',
                            }, { history: false });
                        })
                    } else {
                        throw error;
                    }
                });
        }
    });
});
